import {
  V2ListVendorsForAccountApiArg,
  useV2ListVendorsForAccountQuery,
} from "@generated";
import type { Vendor } from "../types";

export interface UseVendorsListArgs {
  page?: V2ListVendorsForAccountApiArg["page"];
  filter?: V2ListVendorsForAccountApiArg["filter"];
}

export interface VendorsListPageMeta {
  recordCount: number;
  pageCount: number;
}

export const useVendorsList = ({ page, filter }: UseVendorsListArgs) => {
  const { data, error, isLoading, isFetching, refetch } =
    useV2ListVendorsForAccountQuery(
      { page, filter },
      // Refetch on remount (e.g. returning from Edit) so saves are reflected.
      { refetchOnMountOrArgChange: true }
    );

  const rows: Vendor[] = (data?.data ?? []).map((vendor) => ({
    id: String(vendor.id),
    name: vendor.attributes?.name ?? "",
    streetAddress: vendor.attributes?.["street-address"],
    street2: vendor.attributes?.street2,
    city: vendor.attributes?.city,
    state: vendor.attributes?.state,
    postalCode: vendor.attributes?.["postal-code"],
    projectCount: vendor.attributes?.["project-count"],
  }));

  const pageMeta: VendorsListPageMeta = {
    recordCount: data?.meta?.["record-count"] ?? 0,
    pageCount: data?.meta?.["page-count"] ?? 0,
  };

  return { rows, pageMeta, error, isLoading, isFetching, refetch };
};

export default useVendorsList;
